/* global __TARGET__*/
import Reflux from 'reflux';
import { AppActions, StoreActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import { history } from 'helpers';
import Config from 'Config';
import analytics from 'helpers/universalAnalytics';
import FacebookPixel from 'helpers/facebookPixel';

const inProduction = process.env.NODE_ENV === 'production';

var StoreStore = Reflux.createStore({
  listenables: [StoreActions],
  data: {
    list: [],
    loading: true,
    storeId: null,
    storeItem: {},
    docs: {},
    discountCode: localStorage.getItem('discountCode'),
    canIEdit: false,
    theme: {
      color: 'creen'
    }
  },
  getInitialState() {
    return this.data;
  },
  read(name, skipItems, skipLoading) {
    if (!skipLoading) {
      this.data.loading = true;
      this.trigger(this.data);
    }
    const { discountCode } = this.data;
    return SteelCompass.call(
      'store',
      'read',
      { name, skipItems, discountCode },
      response => {
        if (response.isError) {
          StoreActions.genericError(response.errMsg);
        } else {
          StoreActions.readComplete(response.data, name);
        }
        return response.data;
      }
    );
  },
  setDiscountCode(discountCode) {
    localStorage.setItem('discountCode', discountCode);
    this.data = {
      ...this.data,
      discountCode
    };
    this.trigger(this.data);
  },
  fixPrices(list) {
    return list.map(item => ({
      ...item,
      price: {
        ...item.price,
        discounted: Math.ceil(item.price.discounted),
        gross: Math.ceil(item.price.gross)
      }
    }));
  },
  readComplete(data, storeId, skipItems) {
    data.list = data.items ? data.items.slice() : [];
    delete data.items;
    this.data = {
      ...this.data,
      ...data,
      storeId,
      list: skipItems ? this.data.list : this.fixPrices(data.list) || [],
      loading: false
    };
    const googleAnalyticsId =
      inProduction && data.ga ? data.ga.id : Config.googleAnalyticsId;
    analytics.initialize(googleAnalyticsId);
    const options = {
      autoConfig: true,
      debug: false
    };
    const facebookPixelId =
      inProduction && data.js ? data.js.pixel : Config.facebookPixelId;
    FacebookPixel.init(facebookPixelId, null, options);
    FacebookPixel.track('PageView');

    this.trigger(this.data);
  },
  findById(type, id, name) {
    // this.data.loading = true;
    const { discountCode } = this.data;
    this.data.storeItem = {};
    this.trigger(this.data);
    if (this.data.storeId) {
      return SteelCompass.request('store', 'findById', {
        type,
        id,
        discountCode
      }).then(
        data => {
          StoreActions.findByIdComplete(data, type, id);
        },
        error => {
          AppActions.genericError(error);
        }
      );
    }
    return SteelCompass.request('store', 'read', {
      name,
      skipItems: true,
      discountCode
    }).then(
      storeData => {
        return SteelCompass.request('store', 'findById', {
          type,
          id,
          discountCode
        }).then(
          data => {
            StoreActions.findByIdComplete(data, type, id);
            StoreActions.readComplete(storeData, name, true);
          },
          error => {
            AppActions.genericError(error);
          }
        );
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  findBySlug(type, username, slug, callback, skipReset) {
    // this.data.loading = true;
    //
    const { discountCode } = this.data;
    if (!skipReset) {
      this.data.storeItem = {};
      this.trigger(this.data);
    }
    if (this.data.storeId) {
      return SteelCompass.request('store', 'findBySlug', {
        type,
        slug,
        discountCode,
        username
      }).then(
        data => {
          StoreActions.findByIdComplete(data);
          callback && callback(data);
        },
        error => {
          AppActions.genericError(error);
        }
      );
    }
    return SteelCompass.request('store', 'read', {
      name: username,
      skipItems: true,
      discountCode
    }).then(
      storeData => {
        return SteelCompass.request('store', 'findBySlug', {
          discountCode,
          type,
          slug,
          username
        }).then(
          data => {
            callback && callback(data);
            StoreActions.readComplete(storeData, username, true);
            StoreActions.findByIdComplete(data);
          },
          error => {
            AppActions.genericError(error);
          }
        );
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  findByIdComplete(data) {
    if (data) {
      this.data = {
        ...this.data,
        storeItem: {
          ...data,
          price: {
            ...data.price,
            discounted: Math.ceil(data.price.discounted),
            gross: Math.ceil(data.price.gross)
          }
        },
        loading: false
      };
      this.trigger(this.data);
    }
  },
  changeStoreItem(storeItem) {
    if (storeItem.price) {
      this.data = {
        ...this.data,
        storeItem: {
          ...this.data.storeItem,
          ...storeItem,
          price: {
            ...storeItem.price,
            discounted: Math.ceil(storeItem.price.discounted),
            gross: Math.ceil(storeItem.price.gross)
          }
        }
      };
    } else {
      this.data = {
        ...this.data,
        storeItem: {
          ...this.data.storeItem,
          ...storeItem
        }
      };
    }
    this.trigger(this.data);
  },
  pushStoreItem(props) {
    const {
      ucpPeriod,
      price,
      videoUrl,
      presentation,
      type,
      id
    } = this.data.storeItem;
    const isPublic = this.data.storeItem.public;
    this.save(parseInt(type, 10), {
      id,
      ucpPeriod,
      public: isPublic,
      price: price.net,
      videoUrl,
      presentation,
      ...props
    });
  },
  save(type, data) {
    if (type === 1) {
      return SteelCompass.request('course', 'update', data).then(
        () => {
          StoreActions.saveComplete();
          AppActions.translatableMessage('changesSaved');
        },
        error => {
          AppActions.genericError(error);
        }
      );
    } else if (type === 2) {
      return SteelCompass.request('course-package', 'update', data).then(
        () => {
          StoreActions.saveComplete();
          AppActions.translatableMessage('changesSaved');
        },
        error => {
          AppActions.genericError(error);
        }
      );
    }
    // return SteelCompass.call('course-package', 'update', {})
  },
  joinForFree(type, id) {
    const { storeId } = this.data;
    if (type === 1) {
      return SteelCompass.request('course', 'joinForFree', {
        courseId: id,
        storeName: storeId
      }).then(
        () => {
          AppActions.translatableMessage('store.purchaseSuccess');
          setTimeout(() => {
            history.pushState('/dashboard');
          }, 2000);
        },
        error => {
          AppActions.genericError(error);
        }
      );
    } else if (type === 2) {
      return SteelCompass.request('course-package', 'joinForFree', {
        coursePackageId: id,
        storeName: storeId
      }).then(
        () => {
          AppActions.translatableMessage('store.purchaseSuccess');
          setTimeout(() => {
            history.pushState('/dashboard');
          }, 2000);
        },
        error => {
          AppActions.genericError(error);
        }
      );
    }
  },
  saveComplete(data) {}
});

export default StoreStore;



// WEBPACK FOOTER //
// ./src/js/stores/Store.js